import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';

export type NotLeadAction = 'thread' | 'address' | 'domain';

@Component({
  selector: 'email-not-lead-dialog',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './not-lead-dialog.component.html'
})
export class NotLeadDialogComponent implements AfterViewInit, OnChanges {
  @Input() fromEmail?: string;
  @Output() action = new EventEmitter<NotLeadAction>();
  @Output() closed = new EventEmitter<void>();

  @ViewChild('ateModal') modal: ElementRef;

  private popularIspRegex = new RegExp('.*(outlook|hotmail|live|msn|gmail|googlemail|yahoo|ymail|icloud|me|mac|btinternet|btopenworld|btconnect|aol|sky|ntlworld|virginmedia|blueyonder|talktalk|plusnet|tiscali|orange|wanadoo|comcast|xfinity|verizon|att|sbcglobal|cox|bellsouth|earthlink|roadrunner|gmx|web|protonmail|fastmail|zoho|yandex|mail).*');

  get popularIsp(): boolean {
    return this.fromEmail ? this.popularIspRegex.test(this.fromEmail) : false;
  }


  ngAfterViewInit(): void {
    this.modal?.nativeElement.open?.();
  }

  ngOnChanges(): void {
    if (this.modal?.nativeElement) {
      this.modal?.nativeElement.open?.();
    }
  }

  onNativeModalClose(): void {
    this.closed.emit();
  }

  getDomain(email: string): string {
    return email?.split('@')[1] ?? email;
  }

  select(a: NotLeadAction): void {
    this.action.emit(a);
    this.close();
  }

  close(): void {
    this.modal?.nativeElement.close?.();
  }
}
